import CategoryDropdown from '@/components/feature/CategoryDropdown';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex flex-col">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20flat%20lay%20of%20diverse%20fashion%20pieces%20including%20sneakers%20handbags%20sunglasses%20and%20accessories%20scattered%20across%20a%20warm%20sand%20colored%20linen%20surface%2C%20soft%20morning%20sunlight%20streaming%20from%20upper%20right%20creating%20gentle%20shadows%2C%20sophisticated%20lifestyle%20aesthetic%2C%20warm%20ivory%20and%20sand%20tones%2C%20clean%20balanced%20composition%2C%20professional%20product%20photography%2C%20high%20detail%2C%20shallow%20depth%20of%20field%2C%20elegant%20and%20aspirational%20mood&width=1600&height=900&seq=hero-main-v2-01&orientation=landscape"
          alt="OOPBuy Spreadsheet shopping guide hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/35"></div>
      </div>

      <div className="relative z-10 flex flex-col flex-1">
        <div className="flex flex-col lg:flex-row items-center justify-center flex-1 px-6 md:px-10 pt-28 pb-16 gap-10 lg:gap-16">
          <div className="w-full lg:w-1/2 flex flex-col items-start gap-6">
            <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-extrabold text-white leading-[0.95] tracking-tight">
              OOPBuy<br />
              <span className="text-primary-300">Spreadsheet</span>
            </h1>
            <p className="text-white/80 text-lg md:text-xl max-w-lg leading-relaxed">
              Your Smart Shopping Guide — discover the ultimate product sourcing companion 
              that simplifies how you browse, compare, and buy across 14 curated fashion categories.
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mt-2">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="group flex items-center gap-3 px-6 py-3.5 rounded-full bg-white text-foreground-900 text-base font-semibold hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Buy It Now
                <span className="w-7 h-7 flex items-center justify-center rounded-full bg-foreground-900 text-white group-hover:translate-x-0.5 transition-transform duration-200">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </a>
              <div className="hidden sm:block">
                <CategoryDropdown />
              </div>
            </div>
          </div>

          <div className="w-full lg:w-1/2 flex items-center justify-center">
            <div className="relative w-full max-w-[540px] aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20product%20photography%20of%20premium%20lifestyle%20accessories%20including%20leather%20goods%20watch%20and%20designer%20sunglasses%20arranged%20beautifully%20on%20a%20light%20stone%20marble%20surface%2C%20soft%20diffused%20studio%20lighting%2C%20sophisticated%20luxury%20aesthetic%2C%20warm%20champagne%20and%20ivory%20tones%2C%20clean%20elegant%20composition%2C%20high%20detail%2C%20professional%20catalog%20photography%20style%2C%20subtle%20reflective%20surface&width=1080&height=810&seq=hero-side-v2-01&orientation=landscape"
                alt="OOPBuy Spreadsheet product showcase"
                className="w-full h-full object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>

        <div className="relative z-10 pb-8 flex justify-center">
          <a
            href="#categories"
            className="w-11 h-11 flex items-center justify-center rounded-full border-2 border-white/30 text-white hover:border-white/60 hover:bg-white/10 transition-all duration-300 cursor-pointer animate-bounce"
            aria-label="Scroll to categories"
          >
            <i className="ri-arrow-down-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}